import type { Router } from 'vue-router';
import { configureDynamicParamsMenu } from '../helper/menuHelper';
import { Menu } from '../types';
import { PermissionModeEnum } from '/@/enums/appEnum';
import { RouterEnum } from '/@/enums/routerEnum';
import { useAppStoreWithOut } from '/@/store/modules/app';
import { useUserStoreWithOut } from '/@/store/modules/user';
import { useAppStore } from '/@/store/modules/app';

import { usePermissionStoreWithOut } from '/@/store/modules/permission';

const userStore = useUserStoreWithOut();
const appStore = useAppStore();

export function createParamMenuGuard(router: Router) {
  const permissionStore = usePermissionStoreWithOut();
  router.beforeEach(async (to, _, next) => {
    //二级菜单高亮 key值
    // const match = to.path.match(/\/([^/]+)\//);
    // if (match && match[1]) {
    //   if(to.query.from=="MoreHealthIndex"){
    //     appStore.setTwoMenuCurrentKey('health');
    //   }else{
    //     appStore.setTwoMenuCurrentKey(match[1])
    //   }
    // }

    /*
    console.log("toto-->",to)
    if(to.matched.some(record => record.meta.ignoreAuth)){//需要登陆
      if(!isLoggedIn){//没登陆
        next({
          path: '/login',
          query: { redirect: to.fullPath } // 将目标路径传给登录页面，登录完成后回跳
        });  
      }else{
        next(); // 用户已登录，继续访问目标路由
      }
    }else{//不需要登陆
      next(); // 不需要认证的路由直接放行
    }
    */

    // filter no name route
    if (!to.name) {
      next();
      return;
    }

    // menu has been built.
    if (!permissionStore.getIsDynamicAddedRoute) {
      next();
      return;
    }

    let menus: Menu[] = [];
    if (isBackMode()) {
      menus = permissionStore.getBackMenuList;
    } else if (isRouteMappingMode()) {
      menus = permissionStore.getFrontMenuList;
    }
    menus.forEach((item) => configureDynamicParamsMenu(item, to.params));

    /**
     * 唐鑫 2022-4-1
     * 路由导航守卫拦截处理路由变化时，动态设置当前路由的业务所属模块
     * 使菜单能够正确感知并加载相应模块的路由菜单
     */
    if (to.meta.routerType && to.meta.routerType !== RouterEnum.NONE) {
      permissionStore.setCurrentRouterType(to.meta.routerType);
    }

    next();
  });
}
// const isLoggedIn = ()=>{//检查用户是否已登录，
//   console.log("11111-->")
//   const token = userStore.getToken;
//   console.log("token",token)
//   return !!token;
// }
const getPermissionMode = () => {
  const appStore = useAppStoreWithOut();
  return appStore.getProjectConfig.permissionMode;
};

const isBackMode = () => {
  return getPermissionMode() === PermissionModeEnum.BACK;
};

const isRouteMappingMode = () => {
  return getPermissionMode() === PermissionModeEnum.ROUTE_MAPPING;
};
